import { Component } from "react";
import styles from "./general-content-list-item.module.less";
import UiPicture from "@rnb/ui-picture";
import Label from "components/block-elements/label/label";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import { extract } from "@parksandresorts/core";
import { getStandardCardPicture } from "components/helpers/picture-helper";

export default class GeneralContentListItem extends Component {
  constructor(props) {
    super(props);

    this.img = extract(props, "imageInList", null);
    this.shortDescriptionInList = extract(props, "shortDescriptionInList");
    this.title = extract(props, "title");
    this.label = extract(props, "label");
    this.extraClass = extract(props, "extraClass", "");
    this.openInNewTab = extract(props, "link.openInNewTab", false);
    const pageLinkSlug = extract(props, "pageLink.slug");
    this.linkUrl = this.getLinkUrl(pageLinkSlug, props.link);
  }

  getLinkUrl(pageLinkSlug, linkObject) {
    const externalUrl = extract(linkObject, "externalUrl");
    const internalLink = extract(linkObject, "internalLink.slug");

    if (externalUrl) {
      return externalUrl;
    } else if (internalLink) {
      return internalLink;
    } else if (pageLinkSlug) {
      return pageLinkSlug;
    } else {
      return null;
    }
  }

  render() {
    return (
      <div className={[styles.wrapper, this.extraClass ? this.extraClass : ""].join(" ")}>
        <LinkWrapper className={styles.link} url={this.linkUrl} target={this.openInNewTab ? "_blank" : undefined}>
          <div className={styles.labelWrapper}>{this.label && <Label title={this.label} />}</div>
          <div className={styles.imageWrapper}>
            {this.img && (
              <UiPicture
                {...getStandardCardPicture(this.img, `${this.props.contentful_id}_${this.props.id}`)}
                classNamePicture={styles.picture}
              />
            )}
            {this.label && (
              <div className={styles.labelWrapper}>
                <Label title={this.label} />
              </div>
            )}
            {this.readMoreLabel && (
              <div className={[styles.overlayWrapper].join(" ")}>
                <span className={[styles.overlayButton, "p"].join(" ")}>{this.readMoreLabel}</span>
              </div>
            )}
          </div>

          <div className={styles.textWrapper}>
            {this.title && <h5 className={styles.headline}>{this.title}</h5>}
            {this.shortDescriptionInList && (
              <p className={[styles.shortDescription, "p_small"].join(" ")}>{this.shortDescriptionInList}</p>
            )}
          </div>
        </LinkWrapper>
      </div>
    );
  }
}
